import { useState, useEffect } from 'react';
import agent from '@root/agent';

export const useMessageProgress = (conversationId, messageId, isActive) => {
  const [progress, setProgress] = useState(null);
  const [isPolling, setIsPolling] = useState(false);
  const [followUpSuggestions, setFollowUpSuggestions] = useState([]);

  useEffect(() => {
    if (!isActive || !messageId || !conversationId) {
      setProgress(null);
      setIsPolling(false);
      return;
    }


    const pollProgress = async () => {
      try {
        const response = await agent.ViperAI.get_message_progress(conversationId, messageId);

        if (response && response.progress) {
          setProgress(response.progress);

          if (response.progress.status === 'complete') {
            setIsPolling(false);
            setFollowUpSuggestions(response.progress.follow_up_suggestions || []);
            return response.progress.follow_up_suggestions;
          } else if (response.progress.status === 'error') {
            setIsPolling(false);
            return null;
          }
        }
      } catch (error) {
        // Don't stop polling on network errors, just log them
        if (error.response?.status === 404) {
          console.log('Progress not found, stopping polling');
          setIsPolling(false);
        }
      }
    };

    setIsPolling(true);
    const interval = setInterval(pollProgress, 3000); // Poll every 4 seconds

    // Also call immediately
    pollProgress();

    return () => {
      console.log('Cleaning up progress polling');
      clearInterval(interval);
      setIsPolling(false);
    };
  }, [conversationId, messageId, isActive]);

  return { progress, isPolling, followUpSuggestions };
};
